var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Prueba Drag & Drop Jerárquico")]),_c('vue-draggable-tree',{on:{"change":_vm.onTreeChange},model:{value:(_vm.treeData),callback:function ($$v) {_vm.treeData=$$v},expression:"treeData"}}),_c('pre',[_vm._v(_vm._s(JSON.stringify(_vm.treeData, null, 2)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }